import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLockFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10 6H4C3.17157 6 2.5 6.67157 2.5 7.5V11C2.5 11.8284 3.17157 12.5 4 12.5H10C10.8284 12.5 11.5 11.8284 11.5 11V7.5C11.5 6.67157 10.8284 6 10 6Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.5 6.00001V4.20001C4.5 3.53697 4.76339 2.90109 5.23223 2.43225C5.70107 1.9634 6.33696 1.70001 7 1.70001C7.66304 1.70001 8.29893 1.9634 8.76777 2.43225C9.23661 2.90109 9.5 3.53697 9.5 4.20001V6.00001",
		stroke: "currentColor",
		strokeWidth: 1.17
	})]
});
export default SvgLockFilled;
